{
  "branding": {
    "frontdesk-attribution": "Mogelijk gemaakt door FrontDesk+",
    "practice-logo": "Logo van {{name}}"
  },
  "validation": {
    "required": "Dit veld is verplicht",
    "invalid-url": "Voer een geldige URL in",
    "pin-too-short": "PIN moet minimaal 4 tekens bevatten",
    "pin-default-rejected": "De standaardpincode 0000 is niet toegestaan. Wijs uw eigen pincode toe.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Terug",
    "next": "Volgende",
    "cancel": "Annuleren",
    "confirm": "Bevestigen",
    "done": "Klaar",
    "retry": "Opnieuw proberen",
    "clear": "Wissen",
    "close": "Sluiten",
    "verifying": "Verifiëren...",
    "select": "Selecteren",
    "minutes": "minuten",
    "clock": "",
    "gender": {
      "M": "Man",
      "W": "Vrouw",
      "D": "Diverse",
      "U": "Onbekend"
    },
    "insurance": {
      "GKV": "Wettelijk",
      "PKV": "Privé",
      "SELFPAY": "Zelfbetaler"
    },
    "scroll-up": "Omhoog scrollen",
    "scroll-down": "Omlaag scrollen"
  },
  "settings": {
    "device-reset": {
      "title": "Apparaat resetten",
      "description": "Verwijder de praktijkverbinding, instellingen en pincode van dit apparaat.",
      "confirmation": "Dit apparaat moet opnieuw worden ingesteld. De SOL-configuratie en patiëntgegevens in inSuite blijven ongewijzigd.",
      "cancel": "Annuleren",
      "confirm": "Nu resetten"
    },
    "title": "Instellingen",
    "save": "Opslaan",
    "save-success": "Instellingen opgeslagen",
    "save-error": "Instellingen opslaan mislukt",
    "load-error": "Instellingen laden mislukt",
    "pin": {
      "title": "PIN Vereist",
      "description": "Voer uw PIN in om toegang te krijgen tot de instellingen.",
      "error": "Verkeerde PIN. Probeer opnieuw.",
      "backspace": "Laatste cijfer wissen"
    },
    "connection": {
      "title": "Verbinding",
      "description": "Verbindingsinstellingen voor de Doc-Cirrus Bridge-server",
      "bridge-url": "Bridge URL",
      "device-name": "Apparaatnaam",
      "device-name-placeholder": "bijv. Receptie, Kamer 1, Kiosk",
      "device-name-hint": "Naam voor identificatie in het Bridge-dashboard",
      "kim-address": "KIM-adres (optioneel)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Test",
      "success": "Verbinding geslaagd",
      "error": "Verbinding mislukt",
      "api-unreachable": "DocCirrus API onbereikbaar",
      "status-title": "Verbindingsstatus",
      "status": {
        "api": "API verbonden",
        "ti": "Telematica-infrastructuur",
        "card-reader": "Kaartlezer beschikbaar",
        "medical-card": "Praktijkkaart (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Sol-token (uit inSuite)",
      "sol-token-hint": "Kopieer het uit het Bridge-beheer in inSuite. Nodig voor de verbinding.",
      "sol-token-show": "Token tonen",
      "sol-token-hide": "Token niet tonen",
      "bridge-unreachable": "Bridge niet bereikbaar. Controleer het adres en de poort.",
      "diagnostic-id": "Diagnostische ID: {{id}}",
      "scan-qr": "QR-code scannen",
      "scan-title": "Bridge-QR-code scannen",
      "scan-manual": "Handmatig invoeren"
    },
    "terminal": {
      "title": "Kaartlezer",
      "description": "Selectie van de kaartlezer voor de telematica-infrastructuur",
      "select": "Selecteer Terminal",
      "select-placeholder": "Kies terminal...",
      "loading": "Terminals laden...",
      "none-available": "Geen terminals beschikbaar",
      "none-found": "Geen terminals gevonden",
      "found": "{{count}} terminal(s) gevonden",
      "connect-hint": "Maak eerst verbinding met de bridge-server om terminals te laden.",
      "found-count": "Gevonden kaartlezers: {{count}}",
      "refresh": "Kaartlezers opnieuw laden"
    },
    "practice": {
      "title": "Praktijk",
      "description": "Informatie over uw praktijk",
      "name": "Naam van de praktijk",
      "name-placeholder": "bijv. Dr. Jan Jansen",
      "welcome-message": "Welkomstbericht",
      "welcome-placeholder": "bijv. Welkom in onze praktijk",
      "scheduler-available": "Schakel Planner in",
      "scheduler-available-description": "Laat patiënten afspraken boeken via de zelfbedieningsterminal",
      "prescription-available": "Receptservice inschakelen",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Leeg laten om patiënten in hun eigen taal te begroeten. Uw eigen tekst wordt in elke taal ongewijzigd getoond."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Opgeslagen voor alle apparaten op {{value}}",
      "never-saved-default": "Standaardinstelling, nog niet gewijzigd."
    },
    "anamnesis": {
      "title": "Digitale medische geschiedenis",
      "description": "Toont na het inchecken een link en QR code naar uw medische geschiedenisaanbieder.",
      "enabled": "Toon de link naar de medische geschiedenis na het inchecken",
      "enabled-description": "Toont een link en QR code naar uw medische geschiedenisaanbieder na een voltooide check-in, bijvoorbeeld Nelly.",
      "url": "Link naar aanbieder van medische geschiedenis",
      "url-hint": "De link is statisch en identiek voor alle patiënten.",
      "preview-label": "Voorbeeld van voltooiingsscherm",
      "preview-note": "De link is statisch en identiek voor alle patiënten.",
      "url-first": "Voer eerst een geldige link in om dit in te schakelen."
    },
    "appearance": {
      "title": "Uiterlijk",
      "description": "Pas de gebruikersinterface aan",
      "language": "Taal",
      "default-kiosk-language": "Standaard patiënttaal",
      "default-kiosk-language-hint": "Taal waarin nieuwe kiosksessies voor patiënten beginnen.",
      "voice-over-volume": "Voice-overvolume",
      "voice-over-hint": "Regelt het volume van de voice-overassistent voor toegankelijkheid.",
      "language-first": "Toon taalkeuze bij het begin van de sessie"
    },
    "security": {
      "title": "Beveiliging",
      "description": "PIN voor toegang tot instellingen",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Kioskbeheer",
    "nav": {
      "general": "Algemeen",
      "flows": "Functies",
      "anamnese": "Digitale anamnese",
      "device": "Apparaat & verbinding"
    },
    "flows": {
      "title": "Functies op de terminal"
    },
    "language": {
      "title": "Taal & spraak",
      "description": "Taal en voorlezen voor patiënten op dit apparaat."
    }
  },
  "self-service": {
    "title": "Zelfbediening",
    "step-progress": "Stap {{current}} / {{total}}",
    "flows": {
      "checkin": "Inchecken",
      "scheduler": "Afspraak maken",
      "prescription": "Recepten",
      "locations": "Locatiekaart",
      "emergency": "Noodgeval"
    },
    "audio-guide": {
      "on": "Geluid aan",
      "off": "Geluid uit",
      "replay": "Uitleg herhalen",
      "replay-unavailable": "Geen gesproken uitleg om te herhalen"
    },
    "language-selector": {
      "title": "Selecteer taal",
      "description": "Selecteer uw voorkeurstaal"
    },
    "settings": "Instellingen",
    "start": {
      "welcome": "Welkom",
      "subtitle": "Selecteer een optie",
      "check-in-label": "Hoofdpad",
      "check-in-cta": "Inchecken",
      "check-in-description": "Heeft u al een afspraak? Check hier in.",
      "check-in-hint": "Houd uw kaart gereed",
      "scheduler-label": "Nieuw",
      "scheduler-cta": "Afspraak maken",
      "scheduler-description": "Plan een nieuwe afspraak.",
      "location-plan": "Locatiekaart",
      "location-plan-description": "Vind uw weg naar de behandelkamer.",
      "prescription-label": "Recept",
      "prescription-cta": "Recepten en bestellen",
      "prescription-description": "Bekijk recepten of bestel navullingen.",
      "emergency-cta": "Lokaal noodsignaal",
      "emergency-description": "Alleen hoorbaar op dit apparaat; roept geen hulp op.",
      "tap-to-start": "Tik om te beginnen"
    },
    "offline": {
      "banner-title": "Inchecken is tijdelijk niet mogelijk",
      "banner-message": "Neem voor hulp contact op met het receptiepersoneel.",
      "emergency-available": "Het lokale signaal blijft beschikbaar. Het roept geen hulp op.",
      "flow-disabled": "Tijdelijk niet beschikbaar"
    },
    "readability": {
      "toggle-label": "Leesmodus",
      "on": "Leesmodus",
      "off": "Leesmodus"
    },
    "reset-overlay": {
      "timeout-title": "Sessie beëindigd",
      "timeout-subtitle": "Uw tijd is verstreken. Uw gegevens zijn veilig.",
      "offline-title": "Verbinding verbroken",
      "offline-subtitle": "De verbinding werd onderbroken. Neem dan contact op met het receptiepersoneel.",
      "interruption-title": "Sessie beëindigd",
      "interruption-subtitle": "Uw sessie is veilig beëindigd.",
      "completion-title": "Dank je!",
      "completion-subtitle": "Uw aanvraag is succesvol afgerond.",
      "reassurance": "Uw persoonlijke gegevens worden niet op dit apparaat opgeslagen.",
      "auto-dismiss": "Terugkerend naar start over {{seconds}} seconden...",
      "dismiss": "Ga beginnen"
    },
    "timed-terminal": {
      "countdown": "Automatische terugkeer in {{seconds}} seconden",
      "countdown-outcome": "Deze terminal keert automatisch terug naar het startscherm.",
      "more-time": "Meer tijd",
      "extended": "Tijd verlengd"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Deze vragen zijn niet beschikbaar in uw taal. Kies een aangeboden taal of neem contact op met de receptie.",
        "alternatives": "Alternatieve afspraken",
        "loading": "Vragen worden geladen…",
        "reception-fallback": "Ga naar de receptie.",
        "error-title": "De vragen konden niet worden geladen",
        "language-unavailable-lead": "Deze vragen zijn niet beschikbaar in uw taal.",
        "language-unavailable-title": "Kies een van deze talen",
        "language-unavailable-body": "Of laat u helpen bij de receptie."
      },
      "start": {
        "title": "Afspraak maken",
        "subtitle": "Maak uw gewenste afspraak in een paar stappen",
        "welcome": "Welkom bij Afspraak maken",
        "description": "We begeleiden u door het boekingsproces",
        "cta": "Maak nu een afspraak"
      },
      "patient-id": {
        "title": "Identificatie",
        "subtitle": "Identificeer uzelf",
        "mode-card": "Met kaart",
        "mode-search": "Zoeken",
        "mode-create": "Nieuw aanmaken",
        "insert-card": "Plaats uw zorgpas",
        "reading-card": "Kaart lezen...",
        "simulate-card": "Simuleer kaart",
        "multiple-matches": "Meerdere patiënten gevonden. Gebruik kaartgegevens.",
        "search-placeholder": "Naam of verzekeringsnummer...",
        "searching": "Zoeken...",
        "no-results": "Geen resultaten gevonden",
        "first-name": "Voornaam",
        "last-name": "Achternaam",
        "dob": "Geboortedatum",
        "insurance": "Verzekering",
        "continue": "Doorgaan",
        "creating": "Patiënt aanmaken...",
        "patient-created": "Patiënt succesvol aangemaakt!",
        "create-error": "Kan de patiënt niet aanmaken."
      },
      "appointment-type": {
        "title": "Selecteer afspraaktype",
        "subtitle": "Selecteer de reden voor uw bezoek",
        "loading": "Afspraaktypes laden...",
        "no-types": "Geen afspraaktypes beschikbaar",
        "error": "Kon afspraaktypes niet laden. Probeer opnieuw.",
        "no-bookable": "Deze afspraaktypen kunnen momenteel niet via de kiosk worden geboekt. Neem contact op met de balie of maak telefonisch een afspraak.",
        "disabled-default": "Maak deze afspraak rechtstreeks bij de balie of telefonisch.",
        "disabled-footer": "Alleen balie/telefoon",
        "lead": "Wat voor afspraak wilt u maken?",
        "duration": "ca. {{minutes}} minuten",
        "empty-title": "Hier kunnen nu geen afspraken worden gemaakt",
        "none-bookable-title": "Deze afspraken kunt u hier niet maken",
        "none-bookable-body": "Vraag het bij de receptie of bel ons."
      },
      "types": {
        "general": "Algemeen consult",
        "general-desc": "Voor algemene klachten en vragen",
        "checkup": "Preventief onderzoek",
        "checkup-desc": "Regelmatige gezondheidscontroles",
        "vaccination": "Vaccinatie",
        "vaccination-desc": "Plan een vaccinatie",
        "followup": "Vervolgafspraak",
        "followup-desc": "Controleafspraak",
        "prescription": "Recept",
        "prescription-desc": "Recept ophalen"
      },
      "slot-selection": {
        "title": "Selecteer afspraak",
        "subtitle": "Selecteer een beschikbare afspraak",
        "loading": "Beschikbare afspraken laden...",
        "no-slots": "Geen beschikbare afspraken",
        "no-appointment-type": "Geen afspraaktype geselecteerd",
        "error": "Kon beschikbare tijdslots niet laden. Probeer opnieuw.",
        "quick-select": "Eerstvolgende beschikbare afspraken:",
        "select-date": "Of selecteer een datum:",
        "times-for": "{{date}}",
        "available": "Beschikbaar",
        "unavailable": "Geen tijdslots",
        "slots": "tijdslots",
        "select-time-hint": "Tik op een tijd om uw afspraak te boeken",
        "week-short": "Wk",
        "weekday-mon": "Ma",
        "weekday-tue": "Di",
        "weekday-wed": "Wo",
        "weekday-thu": "Do",
        "weekday-fri": "Vr",
        "weekday-sat": "Za",
        "weekday-sun": "Zo",
        "period-morning": "Ochtend",
        "period-midday": "Middag",
        "period-afternoon": "Namiddag",
        "period-evening": "Avond",
        "period-morning-short": "Och.",
        "period-midday-short": "Mid.",
        "period-afternoon-short": "Nam.",
        "period-evening-short": "Av.",
        "period-dots-legend": "Tijdbeschikbaarheid",
        "filter-hint": "Filter op voorkeurstijden:",
        "or-choose-below": "of kies hieronder",
        "no-slots-period": "Geen slots",
        "show-all": "Toon alles",
        "free": "gratis",
        "your-selection": "Jouw selectie",
        "oclock": "uur",
        "choose-slot": "Kies slot",
        "choose-day": "Dag kiezen",
        "choose-day-first": "Kies eerst een dag",
        "times-heading": "Vrije tijden op {{date}}",
        "time-value": "{{time}} uur",
        "empty-title": "Geen vrije afspraken in {{month}}",
        "empty-body": "Kijk in de volgende maand of vraag het bij de receptie – we helpen u graag.",
        "next-month": "Volgende maand",
        "previous-month": "Vorige maand"
      },
      "confirmation": {
        "patient-responses": "Uw antwoorden",
        "review-loading": "Samenvatting controleren…",
        "review-unavailable": "Overzicht niet beschikbaar. Probeer het opnieuw of vraag het bij de receptie.",
        "check-booking": "Boeking controleren",
        "title": "Bevestig afspraak",
        "subtitle": "Controleer uw boeking",
        "patient": "Patiënt",
        "datetime": "Datum en tijd",
        "booking": "Boeken...",
        "confirm": "Afspraak boeken",
        "heading": "Ziet dit er goed uit?",
        "lead": "Bevestig uw afspraak.",
        "appointment": "Afspraak",
        "insured-via": "Verzekerd via",
        "description-label": "Opmerkingen voor de praktijk (optioneel)",
        "description-hint": "Laat ons weten of we bij het plannen of inchecken ergens rekening mee moeten houden.",
        "description-placeholder": "bijv. beperkte mobiliteit, begeleider, belangrijke opmerkingen",
        "description-too-long": "Houd de opmerking op maximaal 500 tekens.",
        "summary": "Samenvatting",
        "change": "Verandering",
        "book-binding": "Boek afspraak",
        "cancel": "Annuleer",
        "type-label": "Soort afspraak",
        "datetime-value": "{{date}} om {{time}} uur",
        "name-label": "Naam",
        "insurance-label": "Verzekering",
        "insurance-GKV": "Wettelijk verzekerd",
        "insurance-PKV": "Particulier verzekerd",
        "insurance-SELFPAY": "Zelfbetaler",
        "change-time": "Afspraak wijzigen",
        "description-free-text": "Overige opmerkingen (optioneel)",
        "note-wheelchair": "Ik gebruik een rolstoel",
        "note-companion": "Ik kom met begeleiding",
        "note-interpreter": "Ik heb een tolk nodig"
      },
      "done": {
        "title": "Afspraak geboekt!",
        "label": "Geboekt",
        "subtitle": "Uw afspraak is succesvol geboekt.",
        "date": "Date",
        "time": "Tijd",
        "booking-id": "Boekingsnummer",
        "qr-hint": "Toevoegen aan uw agenda",
        "qr-description": "Scan deze QR-code met uw smartphone-camera om de afspraak toe te voegen aan uw agenda-app",
        "auto-redirect": "U wordt binnenkort doorgestuurd naar de startpagina...",
        "auto-redirect-countdown": "Terug naar start over {{seconds}} seconden...",
        "back-to-start": "Terug naar start",
        "print-button": "Afspraakbriefje afdrukken",
        "print-preparing": "Afdrukweergave voorbereiden…",
        "print-error": "Het afspraakbriefje kon niet worden geopend. Probeer het opnieuw of vraag hulp bij de receptie.",
        "print-returned": "De afdrukweergave van het systeem is gesloten. U kunt zo nodig nog een exemplaar aanvragen.",
        "print-title": "Uw afspraak",
        "print-location": "Locatie",
        "print-map-hint": "Locatie openen op uw telefoon",
        "print-error-v2": "Het afsprakenbriefje kon niet worden geopend. Probeer het opnieuw of vraag het bij de receptie."
      },
      "error": {
        "assistance-info": "We konden uw boeking niet bevestigen. Uw afspraak is misschien al geboekt. Vraag het bij de receptie.",
        "pending-title": "Boeking niet bevestigd",
        "pending-info": "We konden uw boeking niet bevestigen. Uw afspraak is misschien al geboekt. Controleer het opnieuw of vraag het bij de receptie.",
        "title": "Boeking mislukt",
        "subtitle": "De afspraak kon niet worden geboekt.",
        "info": "Probeer het opnieuw of vraag het bij de receptie."
      },
      "phase": {
        "identify": "Aanmelden",
        "choose": "Tijd kiezen",
        "confirm": "Bevestigen"
      }
    },
    "prescription": {
      "start": {
        "title": "Recepten en bestellen",
        "subtitle": "Voer uw verzekeringskaart in om recepten te bekijken of navullingen te bestellen.",
        "button": "Kaart insteken"
      },
      "card-check": {
        "loading": "Kaartlezer laden...",
        "no-terminal": "Geen kaartlezer geconfigureerd",
        "no-terminal-hint": "Neem voor hulp contact op met het personeel.",
        "insert-card": "Voer uw kaart in",
        "insert-card-hint": "Steek uw verzekeringskaart in de kaartlezer.",
        "card-detected": "Kaart gedetecteerd",
        "reading": "Kaart lezen...",
        "reading-hint": "Wacht even.",
        "error": "Fout bij lezen kaart",
        "retry": "Probeer het opnieuw",
        "manual-lookup": "Ga verder zonder kaart",
        "load-error": "Kan kaartlezer niet laden",
        "read-error": "De kaart kon niet worden gelezen"
      },
      "patient-selection": {
        "title": "Selecteer Patiënt",
        "subtitle": "Er werden meerdere patiënten gevonden. Selecteer uw naam.",
        "try-again": "Probeer het opnieuw",
        "try-again-hint": "Plaats de kaart opnieuw"
      },
      "list": {
        "title": "Uw recepten",
        "for-patient": "Voorschriften voor {{name}}",
        "loading": "Recepten laden...",
        "error-title": "Fout bij laden",
        "fetch-error": "Recepten konden niet worden geladen",
        "back-home": "Terug naar Begin",
        "done": "Klaar"
      },
      "detail": {
        "prescription-info": "Receptinformatie",
        "date": "Date",
        "prescriber": "Voorschrijver",
        "comment": "Let op",
        "medications": "Medicijnen",
        "form": "Vorm",
        "pack-size": "Verpakkingsgrootte",
        "manufacturer": "Fabrikant",
        "loading": "Recept laden...",
        "fetch-error": "Receptgegevens kunnen niet worden geladen",
        "back-to-list": "Terug naar lijst",
        "print": "Afdrukken"
      },
      "types": {
        "public": "Openbaar recept",
        "private": "Privé recept",
        "long-term": "Langdurig recept",
        "btm": "Narcotisch recept",
        "g": "Groen recept",
        "t": "T-recept"
      },
      "no-patient": {
        "title": "Patiënt niet gevonden",
        "subtitle": "Helaas is er voor deze kaart geen patiënt gevonden. Neem voor hulp contact op met het personeel.",
        "try-again": "Probeer het opnieuw",
        "back-home": "Terug naar Begin",
        "title-v2": "Geen passende gegevens gevonden",
        "subtitle-v2": "We konden u niet vinden. Probeer het opnieuw of vraag het bij de receptie."
      },
      "done": {
        "title": "Dank je",
        "subtitle": "U kunt nu gaan zitten. Heeft u vragen, neem dan contact op met het personeel.",
        "no-prescriptions-title": "Geen recepten aanwezig",
        "no-prescriptions-subtitle": "We konden geen actieve recepten voor u vinden. Als u er een verwacht, neem dan contact op met de receptie.",
        "error-title": "Er is een fout opgetreden",
        "error-subtitle": "Neem contact op met het personeel voor verdere hulp.",
        "auto-redirect": "Automatische omleiding in {{seconds}} seconden",
        "finish": "Terug naar Begin"
      },
      "hub": {
        "title": "Uw recepten",
        "for-patient": "Voorschriften voor {{name}}",
        "loading": "Recepten laden...",
        "error-title": "Fout bij laden",
        "fetch-error": "Kan recepten niet laden",
        "back-home": "Terug naar Begin",
        "done": "Klaar",
        "order-button": "Recept bestellen",
        "existing-prescriptions": "Uw huidige recepten",
        "no-prescriptions": "Geen actieve recepten gevonden."
      },
      "patient-lookup": {
        "title": "Vind patiënt",
        "subtitle": "Vul uw naam en geboortedatum in.",
        "last-name": "Achternaam",
        "first-name": "Voornaam",
        "date-of-birth": "Geboortedatum",
        "lastname": "Achternaam",
        "lastname-placeholder": "Je achternaam",
        "firstname": "Voornaam",
        "firstname-placeholder": "Je voornaam",
        "dob": "Geboortedatum",
        "search": "Zoeken",
        "searching": "Zoeken...",
        "search-error": "Zoekfout: {{message}}",
        "no-match": "Geen patiënt gevonden. Controleer uw gegevens.",
        "error": "Zoekfout. Probeer het opnieuw.",
        "found": "Patiënt gevonden",
        "confirm": "Bevestig",
        "ambiguous": "Meerdere wedstrijden",
        "ambiguous-hint-firstname": "Voer ook uw voornaam in om de zoekopdracht te verfijnen.",
        "ambiguous-hint-additional": "Controleer uw gegevens of neem contact op met het personeel.",
        "not-found": "Patiënt niet gevonden",
        "not-found-hint": "Met deze gegevens kon geen patiënt worden gevonden.",
        "not-found-action": "Probeer het opnieuw"
      },
      "manual-identification": {
        "unverified": "Uw identiteit is niet met de zorgpas bevestigd. De praktijk controleert uw gegevens en aanvraag voordat deze wordt verwerkt."
      },
      "medication-selection": {
        "title": "Vraag een recept aan",
        "subtitle": "De praktijk beoordeelt uw aanvraag. Na goedkeuring staat de eRx klaar in uw e-prescription-app.",
        "back": "Terug",
        "submit": "Ga door met beoordelen",
        "reason-title": "Waarom heeft u het recept nodig?",
        "reason-hint": "Helpt de praktijk uw aanvraag te beoordelen.",
        "reason-validation": "Kies een reden.",
        "reason-schmerzen": "Pijn",
        "reason-entzuendung": "Ontsteking",
        "reason-nachsorge": "Na een operatie/procedure",
        "reason-allergie": "Allergie / reactie",
        "reason-chronisch": "Chronische aandoening",
        "reason-anderes": "Iets anders",
        "medications-title": "Welke medicijnen?",
        "request-hint": "Beschrijf wat u nodig heeft, of noem het vorige recept dat u wilt verlengen.",
        "request-placeholder": "bijv. Ibuprofen 600 mg, hetzelfde als de vorige keer",
        "request-validation": "Beschrijf welke medicijnen u nodig heeft.",
        "history-title": "Eerdere recepten",
        "history-hint": "Voeg een vermelding toe om uw verzoek vooraf in te vullen.",
        "history-loading": "Eerdere recepten laden...",
        "history-error": "Eerdere recepten konden niet worden geladen.",
        "history-add": "Toevoegen",
        "history-added": "Toegevoegd",
        "history-date": "Laatste: {{date}}",
        "history-request-line": "Verlengen: {{medicationName}}",
        "urgency-title": "Hoe urgent is het?",
        "urgency-hint": "Helpt de praktijk prioriteit te geven.",
        "urgency-soon": "Urgent",
        "urgency-soon-meta": "Zo snel mogelijk",
        "urgency-tomorrow": "Binnenkort",
        "urgency-tomorrow-meta": "In de komende dagen",
        "urgency-week": "Deze week",
        "urgency-week-meta": "Geen tijdsdruk",
        "lead": "De praktijk beoordeelt uw aanvraag. Na goedkeuring vindt u uw e-recept in de e-recept-app of op uw zorgpas.",
        "history-hint-v2": "Tik op een eerder recept om het over te nemen.",
        "history-retry": "Opnieuw laden"
      },
      "request-review": {
        "title": "Bestelling bekijken",
        "subtitle": "Controleer uw receptaanvraag.",
        "request-label": "Gevraagde medicatie",
        "selected-medications": "Geselecteerde medicijnen",
        "free-text-medications": "Aanvullende medicijnen",
        "freetext-label": "Anders",
        "quarterly-warning": "Uw verzekeringskaart is dit kwartaal niet gelezen. De praktijk kan contact met u opnemen.",
        "egk-warning": "Uw verzekeringskaart is dit kwartaal niet gelezen. De praktijk kan contact met u opnemen.",
        "submit": "Verzenden",
        "submitting": "Verzenden...",
        "submit-error": "Kan het verzoek niet indienen. Probeer het opnieuw.",
        "back": "Terug",
        "reason-label": "Reden",
        "urgency-label": "Urgentie",
        "completion-email-choice": "Ik wil een e-mail ontvangen zodra de praktijk mijn verzoek heeft verwerkt.",
        "completion-email-label": "E-mailadres",
        "completion-email-placeholder": "naam@voorbeeld.nl",
        "completion-email-hint": "Alleen voor dit eenmalige bericht. Het adres wordt niet als stamgegeven opgeslagen.",
        "completion-email-invalid": "Voer een geldig e-mailadres in.",
        "egk-proof-required": "Receptaanvragen zijn alleen beschikbaar na het succesvol lezen van de verzekeringskaart. Neem contact op met het personeel.",
        "title-v2": "Aanvraag controleren",
        "completion-email-hint-v2": "Het adres wordt alleen voor dit ene bericht gebruikt."
      },
      "confirmation": {
        "title": "Verzoek verzonden",
        "subtitle": "Uw receptaanvraag is succesvol ingediend.",
        "success-title": "Verzoek verzonden",
        "success-subtitle": "Uw receptaanvraag is succesvol verzonden.",
        "estimated-time": "Uw recept is klaar over ongeveer {{time}}.",
        "info": "U kunt uw recept ophalen bij de apotheek met uw verzekeringspas of de eRezept app.",
        "auto-redirect": "Automatische omleiding in {{seconds}} seconden",
        "back-to-start": "Terug naar Begin",
        "handling-label": "Handled by the practice",
        "next-steps": "De praktijk beoordeelt uw aanvraag. Na goedkeuring kunt u uw e-recept bij de apotheek inwisselen met uw zorgpas of de e-recept-app."
      },
      "phase": {
        "identify": "Aanmelden",
        "request": "Aanvraag",
        "review": "Controleren"
      }
    },
    "check-in": {
      "flow-label": "Inchecken",
      "has-appointment": {
        "eyebrow": "Afspraak",
        "title": "Heeft u een afspraak?",
        "subtitle": "Selecteer een optie",
        "yes-label": "Ja",
        "yes": "Ja, ik heb een afspraak",
        "yes-description": "Ik wil inchecken voor mijn afspraak.",
        "yes-hint": "Snelste pad",
        "unsure-label": "Misschien",
        "unsure": "Ik weet het niet zeker",
        "unsure-description": "We controleren dat voor u.",
        "unsure-hint": "Wij gaan voor je zoeken",
        "no-label": "Nee",
        "no": "Nee, zonder afspraak",
        "no-description": "Ik heb geen afspraak.",
        "no-hint": "Inloop"
      },
      "card-check": {
        "eyebrow": "Verzekeringskaart",
        "title": "Zorgpas lezen",
        "subtitle": "Plaats uw zorgpas in de lezer",
        "insert-title": "Steek uw zorgverzekeringskaart in de kaartlezer.",
        "insert-detail": "Wij lezen uw gegevens automatisch, u hoeft verder niets te doen.",
        "other-ways": "Andere manieren",
        "no-card-hint": "Als u uw kaart momenteel niet bij u heeft.",
        "pkv-hint": "Gebruik de QR code met uw verzekeringsapp.",
        "loading": "Instellingen laden...",
        "no-terminal": "Geen kaartlezer geconfigureerd. Neem contact op met het personeel.",
        "checking": "Kaarten controleren...",
        "insert-prompt": "Plaats kaart...",
        "card-detected": "Kaart gedetecteerd! Klaar om te lezen.",
        "read-card": "Kaart lezen",
        "simulate-insert": "Simuleer kaart",
        "reading": "Kaart lezen...",
        "error": "Kon kaart niet lezen. Probeer opnieuw.",
        "read-error": "Kon kaartgegevens niet lezen. Probeer opnieuw.",
        "settings-error": "Kon instellingen niet laden. Probeer opnieuw.",
        "no-card-prompt": "Geen kaart bij u?",
        "no-card-action": "Handmatig zoeken",
        "connection-warning": "Verbindingsproblemen met kaartlezer. Even geduld a.u.b....",
        "pkv-prompt": "Particuliere verzekering? Online Check-in",
        "pkv-instruction": "Scan deze QR code met uw particuliere zorgverzekeraar-app om uw gegevens digitaal te verzenden.",
        "pkv-continue": "Ga verder naar handmatige registratie",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Probeer het opnieuw of meld u aan zonder kaart. De receptie helpt u graag.",
        "title-pkv": "Aanmelden met de app",
        "title-reading": "Uw kaart wordt gelezen …",
        "title-unreadable": "Kaart kon niet worden gelezen",
        "title-no-terminal": "Aanmelden zonder kaart",
        "no-terminal-body": "De kaartlezer is op dit moment niet beschikbaar. Meld u aan zonder kaart of ga naar de receptie.",
        "reading-detail": "Laat de kaart in de lezer zitten. Dit duurt maar even.",
        "other-ways-title": "Andere mogelijkheden",
        "no-card-title": "Aanmelden zonder kaart",
        "pkv-prompt-title": "Particulier verzekerd?",
        "pkv-prompt-hint": "Aanmelden met de app van uw particuliere zorgverzekering",
        "pkv-close": "Toch met kaart aanmelden",
        "pkv-instruction-app": "Open de app van uw particuliere zorgverzekering en scan deze code. Uw gegevens komen dan direct bij ons."
      },
      "patient-selection": {
        "title": "Selecteer patiënt",
        "subtitle": "Meerdere patiënten gevonden. Selecteer uzelf.",
        "firstname-label": "Je voornaam",
        "firstname-placeholder": "Voer de voornaam in...",
        "confirm-button": "Bevestig",
        "no-match": "Geen overeenkomende patiënt gevonden. Ga voor hulp naar de receptie.",
        "still-ambiguous": "Er blijven meerdere wedstrijden over. Ga voor hulp naar de receptie.",
        "select-error": "Kan patiënt niet identificeren. Probeer het opnieuw.",
        "staff-assist": "Ga naar de receptie",
        "title-v2": "Korte vraag",
        "subtitle-v2": "Voer voor de zekerheid uw voornaam in.",
        "no-match-v2": "We hebben u met deze voornaam niet gevonden. Controleer de spelling of ga naar de receptie.",
        "still-ambiguous-v2": "We konden u nog niet eenduidig vinden. Ga naar de receptie.",
        "select-error-v2": "Dat is helaas niet gelukt. Probeer het opnieuw."
      },
      "card-checkin": {
        "title": "Bevestig inchecken",
        "subtitle": "Uw gegevens zijn succesvol gelezen.",
        "confirm": "Bevestig inchecken"
      },
      "register-from-card": {
        "title": "Nieuwe registratie",
        "subtitle": "U bent nog niet in ons systeem. Wilt u zich registreren?",
        "card-data": "Kaartgegevens",
        "create": "Registreren",
        "create-error": "Registratie mislukt. Probeer het opnieuw of vraag het personeel om hulp.",
        "staff-assist": "Bel personeel",
        "no-card-data-title": "Geen kaartgegevens",
        "no-card-data": "Kan gegevens van uw kaart niet lezen.",
        "insurance-verified": "Verzekering geverifieerd: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Uw gegevens van de kaart",
        "subtitle-v2": "Controleer uw gegevens. Klopt er iets niet, tik dan op „Wijzigen”.",
        "create-v2": "Gegevens bevestigen",
        "create-error-v2": "Het aanmelden is helaas niet gelukt. Probeer het opnieuw of ga naar de receptie.",
        "insurer-missing-v2": "Op uw kaart staat geen zorgverzekeraar. Ga naar de receptie.",
        "edit": "Wijzigen",
        "name": "Naam",
        "insurer": "Zorgverzekeraar"
      },
      "patient-lookup": {
        "title": "Patiënt zoeken",
        "subtitle": "Voer uw naam of verzekeringsnummer in.",
        "lastname": "Achternaam",
        "lastname-placeholder": "Je achternaam",
        "dob": "Geboortedatum",
        "firstname": "Voornaam",
        "firstname-placeholder": "Je voornaam",
        "search": "Zoeken",
        "searching": "Zoeken...",
        "search-placeholder": "Naam of verzekeringsnummer...",
        "results-placeholder": "Zoekresultaten verschijnen hier",
        "found": "Patiënt gevonden!",
        "confirm-identity": "Bevestig dat u de getoonde patiënt bent.",
        "confirm-button": "Dat ben ik",
        "ambiguous-firstname": "Er werden meerdere patiënten gevonden. Voer uw voornaam in.",
        "ambiguous-additional": "Er werden meerdere patiënten gevonden. Neem dan contact op met het personeel.",
        "disambiguation-hint": "Hierdoor kunnen wij u duidelijk identificeren.",
        "not-found": "Met deze gegevens werd geen patiënt gevonden.",
        "error": "Zoekfout: {{message}}",
        "staff-assist": "Bel personeel",
        "not-found-prompt": "Niet gevonden?",
        "register-new": "Nieuwe registreren",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Aanmelden zonder kaart",
        "subtitle-firstname": "Voer ook uw voornaam in.",
        "ambiguous-firstname-v2": "Er zijn meerdere personen met deze naam. Voer ook uw voornaam in.",
        "search-again": "Opnieuw zoeken",
        "found-v2": "We hebben u gevonden",
        "found-confirm": "Bevestig met „Dat ben ik”.",
        "not-found-title": "We hebben u niet gevonden",
        "not-found-check": "Controleer de spelling en de geboortedatum. De receptie helpt u graag.",
        "not-found-reception": "Controleer de spelling en de geboortedatum of ga naar de receptie.",
        "ambiguous-additional-v2": "We konden u niet eenduidig vinden. Ga naar de receptie.",
        "error-v2": "Het zoeken is op dit moment niet gelukt. Probeer het opnieuw."
      },
      "checking-in": {
        "title": "Een momentje: we zijn u aan het inchecken.",
        "subtitle": "We voegen u toe aan de behandelwachtrij en stellen het team op de hoogte.",
        "step-insurance": "Verzekering gecontroleerd",
        "step-appointment": "Afspraak bevestigd",
        "step-waitlist": "Toevoegen aan wachtlijst",
        "error": "Inchecken is mislukt. Probeer het opnieuw.",
        "continue": "Ga toch door",
        "title-v2": "Een moment alstublieft",
        "loading": "We melden u aan …",
        "subtitle-v2": "We zetten u op de wachtlijst en laten het team het weten.",
        "error-title": "Dat is helaas niet gelukt",
        "error-v2": "Uw aanmelding kon niet worden afgerond.",
        "error-body": "Probeer het opnieuw. Lukt het weer niet, dan helpt de receptie u."
      },
      "appointment-selection": {
        "title": "Selecteer afspraak",
        "subtitle": "Je hebt vandaag verschillende afspraken. Kies er alstublieft één.",
        "checking-in": "Inchecken...",
        "time": "{{time}} uur",
        "error-v2": "Aanmelden voor deze afspraak is niet gelukt. Probeer het opnieuw of ga naar de receptie."
      },
      "no-appointment": {
        "title": "Geen afspraak gevonden",
        "subtitle": "Vandaag konden wij geen afspraak voor u vinden. Maak dan een reguliere afspraak.",
        "book-appointment": "Boek afspraak",
        "book-appointment-description": "Boek een nieuwe afspraak via de reguliere planner.",
        "staff-assist": "Bel personeel",
        "staff-assist-description": "Ik heb hulp nodig.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "We hebben vandaag geen afspraak voor u gevonden.",
        "book-v2": "Nieuwe afspraak maken",
        "book-v2-description": "Kies nu een vrij tijdstip.",
        "have-appointment": "Ik heb een afspraak",
        "have-appointment-description": "De receptie helpt u graag.",
        "unavailable-title": "Afspraken maakt u bij de receptie",
        "subtitle-unavailable": "We hebben vandaag geen afspraak voor u gevonden. Ga naar de receptie."
      },
      "staff-assist": {
        "title": "Personeel op de hoogte gebracht",
        "subtitle": "Een medewerker zal u binnenkort helpen.",
        "message": "Wacht hier alstublieft. Binnenkort komt er een medewerker bij u langs.",
        "start-over": "Terug naar begin",
        "auto-redirect": "Terugkerend naar start over {{seconds}} seconden..."
      },
      "eeb-prompt": {
        "title": "Verzekering verifiëren",
        "title-failed": "Verificatie mislukt",
        "subtitle": "Hoe wilt u uw verzekering verifiëren?",
        "subtitle-failed": "Scan de QR-code met uw verzekerings-app om verificatie aan te vragen.",
        "verify-card": "Elektronisch verifiëren",
        "verify-card-description": "Stuur een verzoek naar uw verzekeraar.",
        "select-insurer": "Selecteer verzekeraar",
        "select-insurer-description": "Handmatige selectie van uw verzekeraar.",
        "skip": "Overslaan",
        "eyebrow-chip": "Alternatief",
        "eyebrow": "Inchecken · verzekeringsbewijs (eEB)",
        "recommended": "Aanbevolen",
        "qr-title": "Scan met uw verzekeringsapp",
        "qr-description": "Open uw zorgverzekeringsapp en scan de code. De eEB wordt rechtstreeks naar ons verzonden.",
        "qr-address-label": "Verzenden naar",
        "title-app": "Bewijs via app",
        "subtitle-app": "Uw zorgverzekeraar kan ons het bewijs ook direct sturen. Bent u klaar, tik dan op „Verder”."
      },
      "quarterly-check": {
        "title": "Verzekeringverificatie",
        "checking": "We controleren uw huidige verzekeringverificatie...",
        "error": "De controle kon niet worden uitgevoerd.",
        "title-v2": "Uw verzekering",
        "checking-v2": "We controleren uw verzekering – een moment alstublieft.",
        "error-body": "Uw aanmelding is klaar. De receptie regelt uw verzekering met u."
      },
      "insurer-prefilled": {
        "title": "Uw zorgverzekering",
        "subtitle": "Bevestig uw verzekering voor dit kwartaal.",
        "your-insurance": "Uw verzekering",
        "last-read": "Laatst geverifieerd op {{date}}",
        "quarterly-notice": "Voor factureringsdoeleinden hebben we een actueel verzekeringsbewijs nodig voor dit kwartaal.",
        "confirm-button": "Ja, dit is mijn verzekering",
        "change-button": "Ik heb een andere verzekering",
        "contact-title": "Vraag elektronisch dekkingsbewijs aan",
        "contact-description": "Bel uw verzekering en vraag een elektronisch dekkingsbewijs aan voor:",
        "contact-patient": "Patiënt",
        "contact-kim-address": "KIM-adres van de praktijk",
        "contact-phone": "Telefoon",
        "question": "Is dit uw zorgverzekeraar?",
        "quarterly-notice-v2": "Eén keer per kwartaal hebben we een bewijs van uw zorgverzekeraar nodig."
      },
      "insurer-search": {
        "title": "Selecteer zorgverzekering",
        "subtitle": "Zoek en selecteer uw wettelijke zorgverzekering.",
        "placeholder": "Zoek verzekering...",
        "hint": "Voer minimaal 2 tekens in om te zoeken.",
        "no-results": "Geen verzekering gevonden.",
        "no-results-hint": "Controleer de spelling of probeer een andere zoekopdracht.",
        "label": "Naam van uw zorgverzekeraar",
        "search-error-v2": "Het zoeken is op dit moment niet gelukt. Probeer het opnieuw.",
        "app-alternative": "Liever met de app van uw zorgverzekeraar?"
      },
      "insurer-contact": {
        "title": "Vraag een verzekeringsbewijs aan",
        "subtitle": "Kies een van de volgende opties.",
        "or": "of",
        "option-eeb-title": "Elektronisch aanvragen",
        "option-eeb-description": "Als het wettelijke uitzonderingsgeval van toepassing is, kunt u de aanvraag na uw toestemming aan het praktijkteam overdragen.",
        "option-qr-title": "Scannen met app",
        "option-qr-description": "Scan de QR code met uw verzekeringsapp.",
        "option-call-title": "Bel jezelf",
        "option-call-description": "Bel uw verzekering en vraag een eEB aan voor deze praktijk:",
        "phone": "Telefoon",
        "phone-not-available": "Telefoonnummer op uw verzekeringskaart",
        "patient-name": "Patiënt",
        "practice-kim": "KIM-adres van de praktijk",
        "help-notice": "Als u problemen ondervindt, kunt u terecht bij de receptie.",
        "submit-eeb-button": "Vraag nu aan",
        "contacted-button": "Ik heb gebeld",
        "contacted-button-countdown": "Tijd voor uw telefoontje ({{seconds}}s)",
        "go-to-counter-button": "Ga naar de receptie",
        "qr-continue-button": "Ik heb gescand",
        "qr-continue-button-countdown": "Tijd om te scannen ({{seconds}}s)",
        "title-v2": "Bewijs van uw zorgverzekeraar",
        "subtitle-v2": "Het makkelijkst gaat het met de app van uw zorgverzekeraar.",
        "subtitle-no-app": "Kies hoe uw zorgverzekeraar ons het bewijs moet sturen.",
        "option-eeb-description-v2": "Wij vragen het voor u aan bij uw zorgverzekeraar. Daarvoor hebben we uw toestemming nodig.",
        "call-instruction": "Bel uw zorgverzekeraar en vraag het bewijs naar onze praktijk te sturen.",
        "call-instruction-practice": "Bel uw zorgverzekeraar en vraag het bewijs naar de praktijk {{practice}} te sturen.",
        "done-button": "Gedaan – verder",
        "done-button-countdown": "Gedaan – verder (nog {{seconds}} s)"
      },
      "eeb-consent": {
        "title": "Toestemming",
        "subtitle": "We hebben uw toestemming nodig voor elektronische verzekeringverificatie.",
        "insurance": "Uw verzekering",
        "consent-title": "Toestemming voor elektronische verzekeringverificatie (eEB)",
        "consent-text": "Ik begrijp dat mijn zorgverzekeraar mijn verzekeringsgegevens (bijv. naam, geboortedatum, verzekeringsnummer) via de beveiligde KIM-communicatiedienst naar de praktijk {{practiceName}} verzendt als verzekeringsbewijs. Ik stem in met deze overdracht. Ik weet dat ik deze toestemming op elk moment kan intrekken zonder gevolgen voor mijn behandeling.",
        "withdrawal-notice": "U kunt deze toestemming op elk moment intrekken.",
        "agree-button": "Ik ga akkoord",
        "decline-button": "Annuleren",
        "treatment-notice": "Uw behandeling wordt niet beïnvloed door deze toestemming.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Bewijs van uw zorgverzekeraar",
        "summary": "Uw zorgverzekeraar stuurt ons het bewijs direct. Daarvoor hebben we uw toestemming nodig.",
        "confirm-first": "Bevestig eerst de verklaring."
      },
      "qr-code": {
        "title": "Scan met verzekerings-app",
        "instruction-1": "Open uw verzekerings-app en scan deze QR-code.",
        "instruction-2": "De praktijk ontvangt daarna automatisch uw verzekeringsverificatie.",
        "practice": "Praktijk: {{name}}",
        "alternative-hint": "Alternatief: Gebruik uw verzekerings-app",
        "instruction-app": "Open de app van uw zorgverzekeraar en scan deze code. Het bewijs komt dan direct bij ons.",
        "staff-line": "Voor het praktijkteam: {{address}}",
        "staff-line-practice": "Voor het praktijkteam: {{name}} · {{address}}",
        "alternative-app": "U kunt het bewijs ook aanvragen met de app van uw zorgverzekeraar: open de app en scan deze code."
      },
      "register-basics": {
        "title": "Persoonlijke informatie",
        "subtitle": "Voer uw gegevens in.",
        "family-name": "Achternaam",
        "given-name": "Voornaam",
        "dob": "Geboortedatum",
        "gender": "Geslacht",
        "insurance-type": "Verzekeringstype",
        "insurer-name": "Naam van uw verzekering",
        "insurer-name-placeholder": "bijv. Debeka, DKV, Allianz...",
        "gender-required": "Kies een optie."
      },
      "register-insurer": {
        "title": "Zorgverzekering",
        "subtitle": "Selecteer uw zorgverzekering.",
        "search-placeholder": "Zoek verzekering..."
      },
      "register-details": {
        "title": "Samenvatting",
        "subtitle": "Controleer uw informatie.",
        "create": "Registratie voltooien",
        "missing-data": "Vul alle verplichte velden in.",
        "create-error": "Registratie mislukt. Probeer het opnieuw.",
        "policy-number": "Polisnummer (optioneel)",
        "policy-number-placeholder": "Uw polisnummer",
        "create-v2": "Aanmelding afronden",
        "policy-number-hint": "U vindt het nummer op de kaart van uw verzekering."
      },
      "diff-review": {
        "eyebrow-chip": "Beoordeling",
        "eyebrow": "Inchecken · kaartgegevens",
        "title": "Gegevensvergelijking",
        "subtitle": "Er zijn verschillen gevonden tussen uw kaartgegevens en onze administratie.",
        "col-current": "Huidig record",
        "col-new": "Nieuw vanaf kaart",
        "new-badge": "nieuw",
        "field-fallback": "Veld",
        "note": "Dankzij bijgewerkte gegevens kunnen we correct factureren en u in geval van nood bereiken.",
        "comparison-placeholder": "Vergelijking wordt hier getoond",
        "confirm": "Bevestig wijzigingen",
        "apply-error": "De gegevens konden niet worden toegepast. Probeer het opnieuw.",
        "retry": "Probeer het opnieuw",
        "skip": "Ga toch door",
        "no-changes": "Geen wijzigingen gevonden",
        "title-v2": "Uw gegevens zijn gewijzigd",
        "subtitle-v2": "Op uw kaart staan nieuwere gegevens. Zullen we die overnemen?",
        "confirm-v2": "Overnemen en aanmelden",
        "keep": "Aanmelden zonder wijziging",
        "col-current-v2": "Eerder",
        "col-new-v2": "Nieuw van de kaart",
        "value-yes": "Ja",
        "value-no": "Nee"
      },
      "insurance-selection": {
        "title": "Verzekeringstype",
        "subtitle": "Selecteer uw verzekeringstype.",
        "gkv": "Wettelijk verzekerd",
        "gkv-description": "Lid van een wettelijke zorgverzekering.",
        "pkv": "Privé of zelfbetaler",
        "pkv-description": "Privé verzekerd of zelfbetaler.",
        "pkv-description-v2": "Particuliere zorgverzekering, of u betaalt zelf."
      },
      "eeb-request": {
        "title": "Aanvraag geregistreerd",
        "subtitle": "U kunt uw check-in afronden. Het antwoord van {{insurer}} komt later bij de praktijk aan.",
        "verifying": "Uw aanvraag is aangenomen voor onmiddellijke verwerking.",
        "success": "Uw aanvraag is veilig overgedragen aan het praktijkteam.",
        "error": "De bevestiging van de aanvraag is niet beschikbaar.",
        "try-alternative": "Alternatieve methode",
        "kim-load-error": "Het KIM-adres van de praktijk kon niet worden geladen.",
        "kim-label": "Praktijk · KIM",
        "non-blocking-note": "Dit bevestigt nog niet de ontvangst door uw zorgverzekeraar of uw verzekeringsstatus.",
        "auto-continue": "Gaat over {{seconds}} seconden automatisch verder.",
        "unavailable-title": "Dat is helaas niet gelukt",
        "unavailable-v2": "Uw aanvraag bij de zorgverzekeraar kon niet worden vastgelegd.",
        "unavailable-body": "U kunt het bewijs laten sturen met de app van uw zorgverzekeraar of het bij de receptie regelen.",
        "use-app": "Met de app",
        "at-reception": "Bij de receptie regelen"
      },
      "self-pay": {
        "title": "Zelfbetaler",
        "subtitle": "U wordt behandeld als zelfbetaler.",
        "info": "Let op dat u verantwoordelijk bent voor de behandelkosten.",
        "confirm": "Begrepen",
        "title-v2": "U betaalt zelf",
        "subtitle-v2": "U betaalt de behandeling zelf.",
        "insured-after-all": "Toch verzekerd"
      },
      "done": {
        "title": "Klaar!",
        "subtitle": "Uw check-in is voltooid.",
        "finish": "Voltooien",
        "done-label": "Klaar",
        "error-label": "Let op",
        "eyebrow": "Inchecken · voltooid",
        "queue-label": "Wachtkamer",
        "queue-title": "Ga alstublieft zitten",
        "queue-meta": "Wij bellen u persoonlijk.",
        "success-title": "Inchecken geslaagd!",
        "success-subtitle": "Neem plaats in de wachtkamer. U wordt geroepen.",
        "auto-redirect": "U wordt binnenkort doorgestuurd naar de startpagina...",
        "auto-redirect-countdown": "Terugkerend naar start over {{seconds}} seconden...",
        "card-expired-title": "Kaart verlopen",
        "card-expired-subtitle": "Uw zorgpas is verlopen.",
        "card-expired-info": "Neem contact op met het personeel voor hulp.",
        "back-to-start": "Terug naar start",
        "anamnesis-title": "Vul het medische geschiedenisformulier in",
        "anamnesis-description": "Scan de QR code om uw medische geschiedenisformulier gemakkelijk op uw smartphone in te vullen.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "U bent aangemeld",
        "card-expired-info-v2": "Ga naar de receptie."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Uw gegevens controleren",
          "balance-prefix": "Bij opslaan:",
          "balance-direct-v2": "Direct opgeslagen: {{count}}",
          "balance-reception-v2": "Gecontroleerd door de receptie: {{count}}",
          "chip-reception-v2": "Wijzigingen worden door onze receptie gecontroleerd",
          "chip-changed": "Gewijzigd: {{count}}",
          "remove": "Verwijderen",
          "example-email": "bijv. naam@voorbeeld.nl",
          "example-phone": "bijv. 06 12345678",
          "intro-v2": "Uw aanmelding is klaar. Kloppen deze gegevens nog? Controleren is vrijwillig.",
          "auto-hide": "Getoonde waarden worden na korte tijd weer verborgen."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "We hebben dit gegeven doorgegeven aan de receptie.",
          "banner-done-v2": "Bedankt! We hebben uw gegevens ontvangen.",
          "footer-v2": "Alle andere gegevens blijven zoals ze zijn."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "Om privacyredenen hebben we de weergave gesloten. Uw aanmelding is toch klaar. Wijzigingen kunt u altijd aan de receptie doorgeven."
        }
      },
      "progress": {
        "identify": "Aanmelden",
        "insurance": "Verzekering",
        "done": "Klaar"
      },
      "dob-format-hint": "Bijvoorbeeld 01.10.1980",
      "dob-required": "Voer uw geboortedatum in.",
      "insurance-label": {
        "GKV": "Wettelijk verzekerd",
        "PKV": "Particulier verzekerd",
        "SELFPAY": "Zelf betalend"
      }
    },
    "emergency": {
      "title": "Acute noodsituatie!",
      "label": "Noodsituatie",
      "subtitle": "Dit signaal is alleen lokaal hoorbaar en heeft geen hulp opgeroepen. Bel 112 bij acute of mogelijk levensbedreigende noodsituaties.",
      "call-emergency": "Bel de hulpdiensten (112)",
      "stop-sound": "Geluid stoppen",
      "play-sound": "Speel geluid af",
      "back-to-start": "Terug naar begin",
      "headline": "Spreek direct het personeel bij de receptie aan. Bij levensgevaar belt u 112."
    },
    "help-reception": "Hulp bij de receptie",
    "help-reception-toast": "Neem contact op met de receptie. Wij helpen u graag.",
    "language-entry": {
      "title": "Kies uw taal"
    },
    "loading": "Laden…",
    "step-progress-label": "Voortgang",
    "step-progress-phase": "Onderdeel {{current}} van {{total}}: {{phase}}",
    "step-progress-substep": "Deel {{current}} van {{total}}",
    "step-progress-complete": "Voltooid",
    "identification": {
      "title": "Wie bent u?",
      "lead": "Het snelst gaat het met uw zorgpas. U kunt ook op uw naam zoeken.",
      "lead-card-only": "Steek uw zorgpas in de kaartlezer.",
      "mode-label": "Hoe wilt u zich aanmelden?",
      "mode-card": "Met pas",
      "mode-search": "Zoeken op naam",
      "mode-create": "Nieuw in de praktijk",
      "card": {
        "loading": "Kaartlezer wordt voorbereid …",
        "checking": "Kaartlezer wordt gecontroleerd …",
        "insert-title": "Steek uw zorgpas in de kaartlezer.",
        "insert-detail": "Wij lezen uw gegevens automatisch.",
        "detected": "Pas herkend",
        "read": "Pas lezen",
        "reading": "Pas wordt gelezen …",
        "reading-hint": "Laat de pas in de lezer zitten.",
        "no-terminal-title": "Kaartlezer niet beschikbaar",
        "help-with-search": "Zoek op uw naam of vraag het bij de receptie.",
        "help-reception": "Vraag het bij de receptie – we helpen u graag.",
        "unreadable-title": "Pas herkend, maar niet leesbaar",
        "error-title": "De pas kon niet worden gelezen",
        "not-unique": "We konden u niet eenduidig aan deze pas koppelen. Zoek op uw naam of vraag het bij de receptie.",
        "no-match": "We vonden geen gegevens bij deze pas. Zoek op uw naam of vraag het bij de receptie.",
        "without-card": "Verder zonder pas"
      },
      "lookup": {
        "lead": "Voer uw achternaam en geboortedatum in.",
        "first-name": "Voornaam",
        "last-name": "Achternaam",
        "dob": "Geboortedatum",
        "dob-hint": "Formaat: DD.MM.JJJJ",
        "search": "Zoeken",
        "confirm": "Ja, dat ben ik",
        "found-title": "We hebben u gevonden",
        "found-body": "Bevestig dat het om u gaat.",
        "first-name-needed-title": "Vul uw voornaam aan",
        "first-name-needed-body": "Zodat we u eenduidig vinden. Tik daarna op ‘Zoeken’.",
        "ambiguous-title": "We konden u niet eenduidig vinden",
        "ambiguous-body": "Vraag het bij de receptie – we helpen u graag.",
        "not-found-title": "Geen passende gegevens gevonden",
        "not-found-body": "Controleer uw invoer.",
        "error-title": "Zoeken is nu niet mogelijk",
        "error-body": "Probeer het opnieuw of vraag het bij de receptie."
      },
      "create": {
        "insurance-question": "Hoe bent u verzekerd?",
        "insurance-required": "Kies hoe u verzekerd bent.",
        "error-title": "Uw gegevens konden niet worden opgeslagen",
        "error-body": "Probeer het opnieuw of vraag het bij de receptie."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Ontgrendel eerst",
      "subtitle": "FrontDesk+ moet geactiveerd zijn in uw praktijksoftware.",
      "step1": "Bestel in SolStore (of uw Doc-Cirrus-partner bestelt voor u).",
      "step2": "Activeer na activering in inSuite onder “inSuite Sols” (adminrechten).",
      "step3": "Open Bridge-beheer → “Apparaat toevoegen”.",
      "cta": "Alles klaar - ga verder"
    },
    "welcome": {
      "title": "Voeg dit apparaat toe aan de praktijk",
      "scan": "Maak een foto van de code",
      "prepare-link": "Geen code in inSuite?",
      "language": "Taal"
    },
    "scan": {
      "requesting": "Cameratoegang wordt gevraagd…",
      "scanning": "Richt de camera op de code",
      "paste": "In plaats daarvan plakken",
      "manual-title": "Handmatig verbinden",
      "manual-description": "Als de QR-code niet beschikbaar is, haalt u de verbindingsgegevens uit de Bridge-administratie.",
      "address-label": "Bridge-adres",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Voeg SOLTOKEN in",
      "manual-submit": "Verbinding overnemen",
      "error-title": "Code niet herkend",
      "camera-denied-title": "Cameratoegang geweigerd",
      "camera-denied-hint": "Sta cameratoegang toe in de instellingen en probeer het opnieuw.",
      "retry": "Probeer het opnieuw"
    },
    "preflight": {
      "title": "Zal worden opgezet",
      "all-green": "Alle tests zijn geslaagd",
      "practice": "Oefening",
      "device-name": "Apparaatnaam",
      "device-name-placeholder": "bijv. B. Ontvangst 1",
      "card-reader": "Kaartlezer",
      "pin": "Nieuw geheim nummer",
      "pin-placeholder": "Viercijferige pincode",
      "finish": "Finish",
      "recheck": "Controleer opnieuw",
      "diagnosis": "Diagnosis ID",
      "checklist-error": "De Bridge heeft de verbinding geweigerd of is niet bereikbaar. Controleer het SOLTOKEN en het Bridge-adres.",
      "checklist-retry": "Opnieuw controleren",
      "edit-token": "SOLTOKEN wijzigen",
      "rescan": "Code opnieuw scannen"
    },
    "persisting": "Instellingen worden opgeslagen …",
    "success": {
      "title": "Apparaat toegevoegd",
      "detail": "Het apparaat is zojuist op de praktijk-pc verschenen.",
      "starting": "Patiëntmodus start…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Koppeling met de praktijksoftware",
        "fix": "Bridge Controleer verbinding en serveradres."
      },
      "missing_insuite_url": {
        "label": "inSuite-adres",
        "fix": "Scan de QR-code opnieuw - het adres ontbreekt."
      },
      "missing_server_token": {
        "label": "Servertoken",
        "fix": "Scan de QR-code opnieuw - het token ontbreekt."
      },
      "missing_gateway_session": {
        "label": "Gateway-sessie",
        "fix": "Meld u opnieuw aan: de sessie ontbreekt."
      },
      "missing_gateway_enrollment": {
        "label": "Apparaatregistratie",
        "fix": "Registreer het apparaat op de Gateway."
      },
      "gateway_not_ready": {
        "label": "Gateway gereedheid",
        "fix": "Wacht tot de Gateway de installatie heeft voltooid."
      },
      "token_verification_failed": {
        "label": "Tokencontrole",
        "fix": "Controleer het servertoken of de Bridge-verbinding."
      },
      "session_expired": {
        "label": "ontmoeting",
        "fix": "De sessie is verlopen - log opnieuw in."
      },
      "device_revoked": {
        "label": "Apparaatstatus",
        "fix": "Dit apparaat is geblokkeerd. Neem contact op met de praktijk."
      },
      "missing_practice_name": {
        "label": "Praktijknaam",
        "fix": "De naam van de medische praktijk kan niet worden geladen (inSuite)."
      },
      "missing_device_name": {
        "label": "Apparaatnaam",
        "fix": "Voer een apparaatnaam in."
      },
      "telematik_unavailable": {
        "label": "Telematica-infrastructuur",
        "fix": "Optioneel – kaartcontrole blijft mogelijk zodra de TI beschikbaar is."
      },
      "selected_card_reader_unavailable": {
        "label": "Kaartlezer",
        "fix": "Optioneel: selecteer of sluit een kaartlezer aan."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Optioneel: voer de identiteitskaart van de medische praktijk in (SMC-B)."
      }
    },
    "token": {
      "title": "SOLTOKEN invoeren",
      "description": "Om veiligheidsredenen bevat de QR-code geen SOLTOKEN. Kopieer het in inSuite onder 'Sol-Aktivierung' (FrontDesk+) en plak het hier.",
      "submit": "Doorgaan",
      "rescan": "Code opnieuw scannen"
    }
  }
}
